<template>
  <div>
    <vs-row
      vs-type="flex"
      class="mb-4"
      vs-justify="center"
      vs-align="center"
      vs-w="12"
    >
      <vs-col vs-w="4" vs-justify="flex-start" vs-align="flex-start">
        <h4 style="color: #b4aa99">Confirmação das OS.</h4>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="8">
        <vs-input
          color="dark"
          class="mx-1"
          size="small"
          type="text"
          placeholder
          label="Busca"
          v-model="filtro.busca"
        ></vs-input>
        <vs-input
          size="small"
          class="mx-2"
          type="date"
          label="Data"
          v-model="filtro.data"
        ></vs-input>
        <div class="mx-1">
          <label style="color: black; font-size: 13px">Turno</label>
          <br />
          <el-select
            filterable
            clearable
            size="small"
            placeholder="Turno"
            v-model="filtro.turno"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="turno in turnos"
              :value="turno.id"
              :label="turno.nome"
              :key="turno.id"
            ></el-option>
          </el-select>
        </div>
        <el-button
          size="small"
          type="primary"
          :disabled="blockButton"
          class="mx-1"
          plain
          @click="filtrar()"
          >FILTRAR</el-button
        >
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-justify="flex-start">
      <vs-col vs-w="3" class="px-2">
        <div>
          <vx-card style="background-color: #000a12; border-radius: 8px 8px 0 0;">
            <h5 style="color: white; margin-bottom: 10px;">
              NÃO CONFIRMADOS: {{ osLista.length }}
            </h5>
            <!-- Barra de Ações integrada ao header -->
            <div class="acoes-header-bar">
              <!-- Último disparo: só ícone + horário, tudo branco -->
              <div class="acoes-ultimo-disparo" title="Último disparo em massa">
                <vs-icon icon="schedule" size="14px" color="white"></vs-icon>
                <span>{{ ultimoJob ? formatarDataJob(ultimoJob.createdAt) : 'Sem disparos' }}</span>
              </div>
              <!-- Botões de ação -->
              <div class="acoes-botoes">
                <vs-button
                  color="#00bba2"
                  type="filled"
                  icon="send"
                  size="small"
                  @click="abrirModalMassa()"
                  :disabled="osLista.length === 0"
                  class="acao-btn"
                >
                  MENSAGEM EM MASSA
                </vs-button>
                <vs-button
                  color="#ea5455"
                  type="filled"
                  icon="event"
                  size="small"
                  @click="abrirModalReagendamento()"
                  class="acao-btn"
                >
                  REAGENDAMENTO
                </vs-button>
              </div>
            </div>
          </vx-card>
          <perfect-scrollbar
            class="scoll-os-confirmacao"
            @ps-y-reach-end="showMoreOsLista()"
          >
            <div id="osLista" class="vs-con-loading__container">
              <div v-if="!osLista.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      <vs-icon
                        size="large"
                        icon="sentiment_dissatisfied"
                      ></vs-icon>
                    </span>
                  </ul>
                </div>
              </div>

              <div v-for="data in osListaShow" :key="data.id" class="mx-2">
                <vx-card :class="cardClass" class="mr-10 my-3">
                  <template slot="no-body">
                    <div class="item-details px-2">
                      <div class="my-1">
                        <div>
                          <vs-col vs-w="9">
                            <vs-col
                              class="mt-1"
                              vs-w="12"
                              vs-type="flex"
                              vs-justify="flex-start"
                              vs-align="flex-start"
                            >
                              <VisualizarCliente
                                @update="close()"
                                :id_cliente="data.id_cliente"
                                :nomeCliente="data.nomeCliente"
                              />
                            </vs-col>
                            <div
                              class="w-full"
                              @click="(iniciarModal = true), (selected = data)"
                            >
                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Contrato
                                  <b>
                                    <a
                                      target="_blank"
                                      :href="'/contrato?id=' + data.id_contrato"
                                      style="color: darkblue; cursor: pointer"
                                      >{{ data.id_contrato }}</a
                                    >
                                  </b>
                                  - Serviço N°
                                  <b>{{ data.id }} - {{ data.tipo }}</b>
                                  <b style="color: black"
                                    >&nbsp;/ {{ data.controle }}</b
                                  >
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Endereco:
                                  <b>
                                    {{ data.logradouro }}, {{ data.numero }},
                                    {{ data.nomeBairro }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-md">
                                  Data:
                                  <b>
                                    {{
                                      data.remarcado > 0
                                        ? data.data_remarcacao
                                        : data.data_competencia
                                    }}
                                  </b>
                                  &nbsp;-&nbsp; Horas:
                                  <b>{{ data.horas_exec }}</b>
                                  &nbsp;-&nbsp;Técnicos:
                                  <b>{{ data.tecnicos_exec }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span
                                  class="item-description text-sm"
                                  v-if="data.obs_interna"
                                >
                                  Obs:
                                  <b>
                                    {{
                                      data.obs_interna
                                        ? data.obs_interna
                                        : "Sem Obs"
                                    }}
                                  </b>
                                </span>
                              </vs-col>
                            </div>
                          </vs-col>
                          <vs-col
                            vs-w="3"
                            vs-type="flex"
                            vs-justify="flex-end"
                            vs-align="flex-end"
                          >
                            <div class="w-full">
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                              >
                                <Badge
                                  v-if="data.hora_marcada"
                                  :text="data.hora_marcada"
                                  color="warning"
                                ></Badge>
                                <Badge
                                  v-else
                                  :text="data.turno"
                                  color="warning"
                                ></Badge>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                              >
                                <Badge
                                  v-if="data.remarcado > 0"
                                  text="REMARCADO"
                                  color="danger"
                                ></Badge>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                              >
                                <Badge
                                  v-if="data.nomeZona != null"
                                  :text="data.nomeZona"
                                  color="orange"
                                ></Badge>
                              </vs-col>
                            </div>
                          </vs-col>
                        </div>
                      </div>
                    </div>
                  </template>
                </vx-card>
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </vs-col>
      <vs-col vs-w="3" class="px-2">
        <div>
          <vx-card style="background-color: #00bba2">
            <vs-row vs-type="flex">
              <vs-col
                vs-w="12"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
              >
                <div>
                  <h5 style="color: white">
                    CONFIRMADOS: {{ osConfirmados.length }}
                  </h5>
                </div>
              </vs-col>
            </vs-row>
          </vx-card>
          <perfect-scrollbar
            class="scoll-os-confirmacao"
            @ps-y-reach-end="showMoreOsConfirmados()"
          >
            <div id="osConfirmados" class="vs-con-loading__container">
              <div v-if="!osConfirmados.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      <vs-icon
                        size="large"
                        icon="sentiment_dissatisfied"
                      ></vs-icon>
                    </span>
                  </ul>
                </div>
              </div>

              <div
                v-for="data in osListaShowConfiramdos"
                :key="data.id"
                class="mx-2"
              >
                <vx-card :class="cardClass" class="mr-10 my-3">
                  <template slot="no-body">
                    <div class="item-details px-2">
                      <div class="my-1">
                        <div>
                          <vs-col vs-w="9">
                            <vs-col
                              vs-w="12"
                              class="mt-1"
                              vs-type="flex"
                              vs-justify="flex-start"
                              vs-align="flex-start"
                            >
                              <VisualizarCliente
                                @update="close()"
                                :id_cliente="data.id_cliente"
                                :nomeCliente="data.nomeCliente"
                              />
                            </vs-col>
                            <div
                              class="w-full"
                              @click="(iniciarModal = true), (selected = data)"
                            >
                              <span class="item-description text-sm">
                                Contrato
                                <b>
                                  <a
                                    target="_blank"
                                    :href="'/contrato?id=' + data.id_contrato"
                                    style="color: darkblue; cursor: pointer"
                                    >{{ data.id_contrato }}</a
                                  >
                                </b>
                                - Serviço N°
                                <b>{{ data.id }} - {{ data.tipo }}</b>
                                <b style="color: black"
                                  >&nbsp;/ {{ data.controle }}</b
                                >
                              </span>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Pessoa confirmação:
                                  <b>{{ data.pessoa_confirmacao }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Endereco:
                                  <b>
                                    {{ data.logradouro }}, {{ data.numero }},
                                    {{ data.nomeBairro }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-md">
                                  Data:
                                  <b>
                                    {{
                                      data.remarcado > 0
                                        ? data.data_remarcacao
                                        : data.data_competencia
                                    }}
                                  </b>
                                  &nbsp;-&nbsp; Horas:
                                  <b>{{ data.horas_exec }}</b>
                                  &nbsp;-&nbsp;Técnicos:
                                  <b>{{ data.tecnicos_exec }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span
                                  class="item-description text-sm"
                                  v-if="data.obs_interna"
                                >
                                  Obs:
                                  <b>
                                    {{
                                      data.obs_interna
                                        ? data.obs_interna
                                        : "Sem Obs"
                                    }}
                                  </b>
                                </span>
                              </vs-col>
                            </div>
                          </vs-col>
                          <vs-col
                            vs-w="3"
                            vs-type="flex"
                            vs-justify="flex-end"
                            vs-align="flex-end"
                          >
                            <div class="w-full">
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                              >
                                <Badge
                                  v-if="data.hora_marcada"
                                  :text="data.hora_marcada"
                                  color="warning"
                                ></Badge>
                                <Badge
                                  v-else
                                  :text="data.turno"
                                  color="warning"
                                ></Badge>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                              >
                                <Badge
                                  v-if="data.nomeZona != null"
                                  :text="data.nomeZona"
                                  color="orange"
                                  class="mt-1"
                                ></Badge>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                              >
                                <Badge
                                  class="mt-1"
                                  v-if="data.confirmado == 2"
                                  text="Sem Visita"
                                  color="danger"
                                  size="small"
                                ></Badge>
                              </vs-col>
                            </div>
                          </vs-col>
                        </div>
                      </div>
                    </div>
                  </template>
                </vx-card>
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </vs-col>
      <vs-col vs-w="3" class="px-2">
        <div>
          <vx-card style="background-color: #ffca28">
            <vs-row vs-type="flex">
              <vs-col
                vs-w="12"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
              >
                <div>
                  <h5 style="color: white">
                    CONFIRMADOS PARA NÃO ENVIAR: {{ osVisitaNaoConfirmada.length }}
                  </h5>
                </div>
              </vs-col>
            </vs-row>
          </vx-card>
          <perfect-scrollbar
            class="scoll-os-confirmacao"
            @ps-y-reach-end="showMoreOsVisitaNaoConfirmada()"
          >
            <div id="osVisitaNaoConfirmada" class="vs-con-loading__container">
              <div v-if="!osVisitaNaoConfirmada.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      <vs-icon
                        size="large"
                        icon="sentiment_dissatisfied"
                      ></vs-icon>
                    </span>
                  </ul>
                </div>
              </div>

              <div
                v-for="data in osListaShowVisitaNaoConfirmada"
                :key="data.id"
                class="mx-2"
              >
                <vx-card :class="cardClass" class="mr-10 my-3">
                  <template slot="no-body">
                    <div class="item-details px-2">
                      <div class="my-1">
                        <div>
                          <vs-col vs-w="9">
                            <vs-col
                              vs-w="12"
                              class="mt-1"
                              vs-type="flex"
                              vs-justify="flex-start"
                              vs-align="flex-start"
                            >
                              <VisualizarCliente
                                @update="close()"
                                :id_cliente="data.id_cliente"
                                :nomeCliente="data.nomeCliente"
                              />
                            </vs-col>
                            <div
                              class="w-full"
                              @click="(iniciarModal = true), (selected = data)"
                            >
                              <span class="item-description text-sm">
                                Contrato
                                <b>
                                  <a
                                    target="_blank"
                                    :href="'/contrato?id=' + data.id_contrato"
                                    style="color: darkblue; cursor: pointer"
                                    >{{ data.id_contrato }}</a
                                  >
                                </b>
                                - Serviço N°
                                <b>{{ data.id }} - {{ data.tipo }}</b>
                                <b style="color: black"
                                  >&nbsp;/ {{ data.controle }}</b
                                >
                              </span>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Pessoa confirmação:
                                  <b>{{ data.pessoa_confirmacao }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Endereco:
                                  <b>
                                    {{ data.logradouro }}, {{ data.numero }},
                                    {{ data.nomeBairro }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-md">
                                  Data:
                                  <b>
                                    {{
                                      data.remarcado > 0
                                        ? data.data_remarcacao
                                        : data.data_competencia
                                    }}
                                  </b>
                                  &nbsp;-&nbsp; Horas:
                                  <b>{{ data.horas_exec }}</b>
                                  &nbsp;-&nbsp;Técnicos:
                                  <b>{{ data.tecnicos_exec }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span
                                  class="item-description text-sm"
                                  v-if="data.obs_interna"
                                >
                                  Obs:
                                  <b>
                                    {{
                                      data.obs_interna
                                        ? data.obs_interna
                                        : "Sem Obs"
                                    }}
                                  </b>
                                </span>
                              </vs-col>
                            </div>
                          </vs-col>
                          <vs-col
                            vs-w="3"
                            vs-type="flex"
                            vs-justify="flex-end"
                            vs-align="flex-end"
                          >
                            <div class="w-full">
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                              >
                                <Badge
                                  v-if="data.hora_marcada"
                                  :text="data.hora_marcada"
                                  color="warning"
                                ></Badge>
                                <Badge
                                  v-else
                                  :text="data.turno"
                                  color="warning"
                                ></Badge>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                              >
                                <Badge
                                  v-if="data.nomeZona != null"
                                  :text="data.nomeZona"
                                  color="orange"
                                  class="mt-1"
                                ></Badge>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                              >
                                <Badge
                                  class="mt-1"
                                  v-if="data.confirmado == 2"
                                  text="Sem Visita"
                                  color="danger"
                                  size="small"
                                ></Badge>
                              </vs-col>
                            </div>
                          </vs-col>
                        </div>
                      </div>
                    </div>
                  </template>
                </vx-card>
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </vs-col>
      <vs-col vs-w="3" class="px-2">
        <div>
          <vx-card style="background-color: #f44336">
            <vs-row vs-type="flex">
              <vs-col
                vs-w="12"
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
              >
                <div>
                  <h5 style="color: white">
                    REMARCADOS: {{ osRemarcados.length }}
                  </h5>
                </div>
              </vs-col>
            </vs-row>
          </vx-card>
          <perfect-scrollbar
            class="scoll-os-confirmacao"
            @ps-y-reach-end="showMoreOsRemarcados()"
          >
            <div id="osRemarcados" class="vs-con-loading__container">
              <div v-if="!osRemarcados.length > 0">
                <div class="con-colors">
                  <ul>
                    <span
                      class="px-3 pt-2"
                      style="
                        color: grey !important;
                        font-weight: 1000 !important;
                      "
                    >
                      <vs-icon
                        size="large"
                        icon="sentiment_dissatisfied"
                      ></vs-icon>
                    </span>
                  </ul>
                </div>
              </div>

              <div
                v-for="data in osListaShowRemarcados"
                :key="data.id"
                class="mx-2"
              >
                <vx-card :class="cardClass" class="mr-10 my-3">
                  <template slot="no-body">
                    <div class="item-details px-2">
                      <div class="my-1">
                        <div>
                          <vs-col vs-w="9">
                            <vs-col
                              vs-w="12"
                              class="mt-1"
                              vs-type="flex"
                              vs-justify="flex-start"
                              vs-align="flex-start"
                            >
                              <VisualizarCliente
                                @update="close()"
                                :id_cliente="data.id_cliente"
                                :nomeCliente="data.nomeCliente"
                              />
                            </vs-col>
                            <div
                              class="w-full"
                              @click="(iniciarModal = true), (selected = data)"
                            >
                              <span class="item-description text-sm">
                                Contrato
                                <b>
                                  <a
                                    target="_blank"
                                    :href="'/contrato?id=' + data.id_contrato"
                                    style="color: darkblue; cursor: pointer"
                                    >{{ data.id_contrato }}</a
                                  >
                                </b>
                                - Serviço N°
                                <b>{{ data.id }} - {{ data.tipo }}</b>
                                <b style="color: black"
                                  >&nbsp;/ {{ data.controle }}</b
                                >
                              </span>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-sm">
                                  Endereco:
                                  <b>
                                    {{ data.logradouro }}, {{ data.numero }},
                                    {{ data.nomeBairro }}
                                  </b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span class="item-description text-md">
                                  Data:
                                  <b>
                                    {{
                                      data.remarcado > 0
                                        ? data.data_remarcacao
                                        : data.data_competencia
                                    }}
                                  </b>
                                  &nbsp;-&nbsp; Horas:
                                  <b>{{ data.horas_exec }}</b>
                                  &nbsp;-&nbsp;Técnicos:
                                  <b>{{ data.tecnicos_exec }}</b>
                                </span>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                class="mt-1"
                                vs-type="flex"
                                vs-justify="flex-start"
                                vs-align="flex-start"
                              >
                                <span
                                  class="item-description text-sm"
                                  v-if="data.obs_interna"
                                >
                                  Obs:
                                  <b>
                                    {{
                                      data.obs_interna
                                        ? data.obs_interna
                                        : "Sem Obs"
                                    }}
                                  </b>
                                </span>
                              </vs-col>
                            </div>
                          </vs-col>
                          <vs-col
                            vs-w="3"
                            vs-type="flex"
                            vs-justify="flex-end"
                            vs-align="flex-end"
                          >
                            <div class="w-full">
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                              >
                                <Badge
                                  v-if="data.hora_marcada"
                                  :text="data.hora_marcada"
                                  color="warning"
                                ></Badge>
                                <Badge
                                  v-else
                                  :text="data.turno"
                                  color="warning"
                                ></Badge>
                              </vs-col>
                              <vs-col
                                vs-w="12"
                                vs-type="flex"
                                vs-justify="flex-end"
                                vs-align="flex-end"
                              >
                                <Badge
                                  v-if="data.nomeZona != null"
                                  :text="data.nomeZona"
                                  color="orange"
                                ></Badge>
                              </vs-col>
                            </div>
                          </vs-col>
                        </div>
                      </div>
                    </div>
                  </template>
                </vx-card>
              </div>
            </div>
          </perfect-scrollbar>
        </div>
      </vs-col>
    </vs-row>
    <vs-popup
      class
      :title="'' + selected.nomeCliente"
      :active.sync="iniciarModal"
    >
      <vs-row vs-type="flex" vs-align="center">
        <vs-col
          vs-w="4"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          class="p-5"
        >
          <modalConfirmarOs
            @update="close()"
            :item="selected"
          ></modalConfirmarOs>
        </vs-col>
        <vs-col
          vs-w="4"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          class="p-5"
        >
          <modalReagendarOs
            @close="iniciarModal = false"
            @update="close()"
            :item="selected"
          ></modalReagendarOs>
        </vs-col>
        <vs-col
          vs-w="4"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          class="p-5"
        >
          <modalContactar
            @update="close()"
            @confirmacao-atualizada="atualizarContatoConfirmacaoLocal"
            @fechar-pai="iniciarModal = false"
            :item="selected"
            tipo="os_confirmacao"
          ></modalContactar>
        </vs-col>
      </vs-row>
    </vs-popup>

    <modal-disparo-em-massa
      :active.sync="modalMassaActive"
      :osList="osLista"
      tipo="os_confirmacao"
      @success="fecharModalMassaComSucesso"
    />

    <modal-reagendamento-massa
      :active="modalReagendamentoActive"
      :os-list="osLista"
      @update:active="val => { if (!val) fecharModalReagendamento() }"
      @success="fecharModalReagendamentoComSucesso"
    />

  </div>
</template>
<script>
import components from "@/components/default/exports.js";
import modalConfirmarOs from "./components/modalConfirmarOs.vue";
import modalReagendarOs from "./components/modalReagendarOs.vue";
import modalContactar from "./components/contactarModal";
import VisualizarCliente from "./../cliente/visualizar.vue";
import ModalDisparoEmMassa from "./components/modalDisparoEmMassa.vue";
import ModalReagendamentoMassa from "./components/modalReagendamentoMassa.vue";

export default {
  components: {
    modalConfirmarOs,
    modalReagendarOs,
    modalContactar,
    VisualizarCliente,
    ModalDisparoEmMassa,
    ModalReagendamentoMassa,
    ...components,
  },
  data() {
    return {
      filtro: {
        dataHoje: this.$formartData.dataFiltro(),
        data: null,
        turno: null,
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.8,
      },
      cardClass: "os-card overflow-hidden",
      selected: [],
      iniciarModal: false,
      modalMassaActive: false,
      modalReagendamentoActive: false,
      ultimoJob: null,
      osLista: [],

      osListaShow: [],
      osListaShowCount: 2,

      osListaShowConfiramdos: [],
      osListaShowConfiramdosCount: 2,

      osListaShowRemarcados: [],
      osListaShowRemarcadosCount: 2,

      osListaShowVisitaNaoConfirmada: [],
      osListaShowVisitaNaoConfirmadaCount: 2,

      osConfirmados: [],
      osVisitaNaoConfirmada: [],
      osRemarcados: [],
      turnos: [
        { id: null, nome: "Nenhum" },
        { id: 1, nome: "Manha" },
        { id: 2, nome: "Almoco" },
        { id: 3, nome: "Tarde" },
        { id: 4, nome: "Noite" },
        { id: 5, nome: "Madrugada" },
      ],
      blockButton: false,
    };
  },
  async mounted() {
    this.filtro.data = this.$formartData.dataFiltro();
    this.$vs.loading();
    
    // Buscar em paralelo as OS e o status do ultimo job
    await Promise.all([
      this.getOsLista(),
      this.getosConfirmados(),
      this.getOsRemarcados(),
      this.getUltimoJobStatus()
    ]);
    
    this.$vs.loading.close();

    // Auto-open modal AFTER data loads, and open on correct tab
    const queryTab = this.$route.query.disparo_aba || new URLSearchParams(window.location.search).get('disparo_aba');
    if (queryTab) {
      console.log("[osConfirmacao] Query 'disparo_aba' detectada. Abrindo modal automaticamente com aba:", queryTab);
      await this.$nextTick();
      if (queryTab === 'historico') {
        this.abrirModalHistorico();
      } else {
        this.abrirModalMassa();
      }
    }

    // Auto-open modal de reagendamento se URL tiver ?modal=reagendamento
    const modalQuery = this.$route.query.modal || new URLSearchParams(window.location.search).get('modal');
    if (modalQuery === 'reagendamento') {
      await this.$nextTick();
      this.abrirModalReagendamento();
    }
  },
  methods: {
    async getUltimoJobStatus() {
      try {
        const res = await this.$http.get('whatsapp/enviar-massa/ultimo-job/os_confirmacao');
        const responseData = res.data || res;
        this.ultimoJob = responseData.data !== undefined ? responseData.data : responseData;
      } catch (err) {
        console.error("Erro ao buscar histórico do disparo em massa:", err);
      }
    },
    formatarDataJob(dataIso) {
      if (!dataIso) return '';
      const data = new Date(dataIso);
      return data.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
    },
    fecharModalMassaComSucesso() {
      console.log("[osConfirmacao] Fechando modal de disparo em massa com sucesso.");
      this.modalMassaActive = false;
      this.getDadosDashboard();
    },
    fecharModalReagendamentoComSucesso() {
      console.log("[osConfirmacao] Fechando modal de reagendamento em massa com sucesso.");
      this.fecharModalReagendamento();
      this.getDadosDashboard();
    },
    abrirModalReagendamento() {
      // Sincroniza URL ao abrir o modal de reagendamento
      const url = new URL(window.location);
      url.searchParams.set('modal', 'reagendamento');
      window.history.replaceState({}, '', url);
      this.modalReagendamentoActive = true;
    },
    fecharModalReagendamento() {
      // Remove o param da URL ao fechar o modal de reagendamento
      const url = new URL(window.location);
      url.searchParams.delete('modal');
      window.history.replaceState({}, '', url);
      this.modalReagendamentoActive = false;
    },
    abrirModalMassa() {
      console.log("[osConfirmacao] Botão 'MENSAGEM EM MASSA' clicado.");
      console.log("[osConfirmacao] Total de OS não confirmadas na lista (osLista):", this.osLista.length);
      
      const url = new URL(window.location);
      url.searchParams.set('disparo_aba', 'novo');
      window.history.replaceState({}, '', url);
      if (this.$route && this.$route.query) {
        this.$route.query.disparo_aba = 'novo';
      }

      this.modalMassaActive = true;
    },
    abrirModalHistorico() {
      console.log("[osConfirmacao] Botão de histórico de disparos clicado.");
      
      const url = new URL(window.location);
      url.searchParams.set('disparo_aba', 'historico');
      window.history.replaceState({}, '', url);
      if (this.$route && this.$route.query) {
        this.$route.query.disparo_aba = 'historico';
      }
      this.modalMassaActive = true;
    },
    async getDadosDashboard() {
      await Promise.all([
        this.getOsLista(), 
        this.getosConfirmados(), 
        this.getOsRemarcados(),
        this.getUltimoJobStatus()
      ]);
    },
    async getOsLista() {
      await this.$vs.loading({ container: "#osLista", scale: 0.6 });
      try {
        this.osLista = await this.$http.post(`getOsLista`, this.filtro);
        this.osListaShow = this.osLista.slice(0, 10);
        // this.osListaShow = this.osLista;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      await this.$vs.loading.close("#osLista > .con-vs-loading");
    },

    async getosConfirmados() {
      await this.$vs.loading({ container: "#osConfirmados", scale: 0.6 });
      this.$vs.loading({ container: "#osVisitaNaoConfirmada", scale: 0.6 });
      try {
        const response = await this.$http.post(
          `getOsConfirmados`,
          this.filtro,
        );
        this.osVisitaNaoConfirmada = response.filter((os) => os.confirmado == 2)
        this.osConfirmados = response.filter((os) => os.confirmado == 1)

        this.osListaShowConfiramdos = this.osConfirmados.slice(0, 10);
        this.osListaShowVisitaNaoConfirmada = this.osVisitaNaoConfirmada.slice(0, 10);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      await this.$vs.loading.close("#osConfirmados > .con-vs-loading");
      await this.$vs.loading.close("#osVisitaNaoConfirmada > .con-vs-loading");
    },

    async getOsRemarcados() {
      await this.$vs.loading({ container: "#osRemarcados", scale: 0.6 });
      try {
        this.osRemarcados = await this.$http.post(
          `getOsRemarcados`,
          this.filtro,
        );

        this.osListaShowRemarcados = this.osRemarcados.slice(0, 10);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
      await this.$vs.loading.close("#osRemarcados > .con-vs-loading");
    },

    async showMoreOsLista() {
      if (
        this.osLista.length > 10 &&
        this.osLista.length > this.osListaShow.length
      ) {
        this.$vs.loading();
        await setTimeout(() => {
          this.osListaShow = this.osLista.slice(0, 10 * this.osListaShowCount);
          this.osListaShowCount += 1;
          this.$vs.loading.close();
        }, 200);
      }
    },

    async showMoreOsConfirmados() {
      if (
        this.osConfirmados.length > 10 &&
        this.osConfirmados.length > this.osListaShowConfiramdos.length
      ) {
        this.$vs.loading();
        await setTimeout(() => {
          this.osListaShowConfiramdos = this.osConfirmados.slice(
            0,
            10 * this.osListaShowConfiramdosCount,
          );
          this.osListaShowConfiramdosCount += 1;
          this.$vs.loading.close();
        }, 200);
      }
    },

    showMoreOsVisitaNaoConfirmada() {
      if (
        this.osVisitaNaoConfirmada.length > 10 &&
        this.osVisitaNaoConfirmada.length > this.osListaShowVisitaNaoConfirmada.length
      ) {
        this.$vs.loading();
        setTimeout(() => {
          this.osListaShowVisitaNaoConfirmada = this.osVisitaNaoConfirmada.slice(
            0,
            10 * this.osListaShowVisitaNaoConfirmadaCount,
          );
          this.osListaShowVisitaNaoConfirmadaCount += 1;
          this.$vs.loading.close();
        }, 200);
      }
    },

    async showMoreOsRemarcados() {
      if (
        this.osRemarcados.length > 10 &&
        this.osRemarcados.length > this.osListaShowRemarcados.length
      ) {
        this.$vs.loading();
        await setTimeout(() => {
          this.osListaShowRemarcados = this.osRemarcados.slice(
            0,
            10 * this.osListaShowRemarcadosCount,
          );
          this.osListaShowRemarcadosCount += 1;
          this.$vs.loading.close();
        }, 200);
      }
    },

    async filtrar() {
      this.blockButton = true;
      await this.getDadosDashboard();
      this.blockButton = false;
    },
    async closeModalReagendar() {
      this.iniciarModal = await false;
    },
    async close() {
      this.iniciarModal = await false;
      await this.getDadosDashboard();
    },
    atualizarContatoConfirmacaoNaLista(
      lista,
      idContrato,
      idContatoConfirmacao,
      nomeContatoConfirmacao,
      contatoConfirmacao
    ) {
      if (!Array.isArray(lista)) {
        return;
      }
      lista.forEach((item) => {
        if (item.id_contrato == idContrato) {
          item.id_contato_confirmacao = idContatoConfirmacao;
          if (nomeContatoConfirmacao !== undefined) {
            item.nomeContatoConfirmacao = nomeContatoConfirmacao;
          }
          if (contatoConfirmacao !== undefined) {
            item.contatoConfirmacao = contatoConfirmacao;
          }
        }
      });
    },
    atualizarContatoConfirmacaoLocal({ idContrato, idContatoConfirmacao, nomeContatoConfirmacao, contatoConfirmacao }) {
      this.atualizarContatoConfirmacaoNaLista(
        this.osLista,
        idContrato,
        idContatoConfirmacao,
        nomeContatoConfirmacao,
        contatoConfirmacao
      );
      this.atualizarContatoConfirmacaoNaLista(
        this.osListaShow,
        idContrato,
        idContatoConfirmacao,
        nomeContatoConfirmacao,
        contatoConfirmacao
      );
      this.atualizarContatoConfirmacaoNaLista(
        this.osConfirmados,
        idContrato,
        idContatoConfirmacao,
        nomeContatoConfirmacao,
        contatoConfirmacao
      );
      this.atualizarContatoConfirmacaoNaLista(
        this.osListaShowConfiramdos,
        idContrato,
        idContatoConfirmacao,
        nomeContatoConfirmacao,
        contatoConfirmacao
      );
      this.atualizarContatoConfirmacaoNaLista(
        this.osRemarcados,
        idContrato,
        idContatoConfirmacao,
        nomeContatoConfirmacao,
        contatoConfirmacao
      );
      this.atualizarContatoConfirmacaoNaLista(
        this.osListaShowRemarcados,
        idContrato,
        idContatoConfirmacao,
        nomeContatoConfirmacao,
        contatoConfirmacao
      );

      if (this.selected && this.selected.id_contrato == idContrato) {
        this.selected.id_contato_confirmacao = idContatoConfirmacao;
        if (nomeContatoConfirmacao !== undefined) {
          this.selected.nomeContatoConfirmacao = nomeContatoConfirmacao;
        }
        if (contatoConfirmacao !== undefined) {
          this.selected.contatoConfirmacao = contatoConfirmacao;
        }
      }
    },
    async loadingModal() {
      await this.$vs.loading({ container: "#loading", scale: 0.6 });
    },
  },
};
</script>
<style scoped lang="scss">
.list-item {
  background-color: #fff;
  transition: background 0.1s ease-in-out;
  border-radius: 3px;
  font-size: 16px;
}
.list-item:hover {
  background: #dcdcdc;
}
.active-list-item {
  background-color: #000a12;
  transition: background 0.1s ease-in-out;
  border-radius: 3px;
  font-size: 16px;
  color: #ffca00;
}
.os-card {
  transition-duration: 50ms;
  &:hover {
    transition-duration: 150ms;
    transform: translateY(-3px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);
    background-color: #eeeeee;
    color: black;
    cursor: pointer;

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
.scoll-os-confirmacao {
  height: 70vh !important;
}
.bg-dark-premium {
  background: linear-gradient(145deg, #0f172a 0%, #1e293b 100%) !important;
  border-left: 4px solid #f59e0b;
}

/* Barra de ações integrada ao header da coluna NÃO CONFIRMADOS */
.acoes-header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  flex-wrap: wrap;
}
.acoes-ultimo-disparo {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
  white-space: nowrap;
}
.acoes-botoes {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.acao-btn {
  font-size: 10px !important;
  font-weight: 700 !important;
  padding: 5px 10px !important;
  white-space: nowrap;
}
/* Responsivo: empilha verticalmente em telas menores */
@media (max-width: 1200px) {
  .acoes-header-bar {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .acoes-botoes {
    width: 100%;
    flex-wrap: wrap;
  }
  .acao-btn {
    flex: 1;
    justify-content: center;
  }
}
</style>
